import React from 'react';
import * as Ons from 'react-onsenui';

class Toolbar extends React.Component {

    render() {

        return (

            <Ons.Toolbar className={this.props.title ? '' : 'no-title'}>

                {
                    this.props.onBackClick &&
                    <div className="left">
                        <Ons.ToolbarButton onClick={this.props.onBackClick}>
                            <Ons.Icon icon="ion-ios-arrow-back, material:md-arrow-back" />
                        </Ons.ToolbarButton>
                    </div>
                }

                <div className="center">{this.props.title}</div>

                <div className="right">
                    {
                        this.props.right ? this.props.right :

                            (
                                <>
                                    { this.props.onReloadClick && <Ons.ToolbarButton onClick={this.props.onReloadClick}><Ons.Icon icon="ion-ios-refresh, material:md-refresh" /></Ons.ToolbarButton> }
                                    <Ons.ToolbarButton onClick={this.props.onMenuClick}><Ons.Icon icon="ion-ios-menu, material:md-menu" /></Ons.ToolbarButton>
                                </>
                            )
                    }
                </div>

            </Ons.Toolbar>

        );

    }

}

export default Toolbar;